import Vue from 'vue'

let nextId = 1

export const state = Vue.observable({ toasts: [] })

export function toast(message, { type = 'success', duration = 4000 } = {}) {
  const id = nextId++
  state.toasts.push({ id, message, type })

  setTimeout(() => dismissToast(id), duration)
}

export function dismissToast(id) {
  state.toasts = state.toasts.filter((toast) => toast.id !== id)
}

// For flows that reload the page after success (e.g. settings save):
// stores the toast in sessionStorage so it can be shown after the reload.
const PENDING_TOAST_KEY = 'pending_toast'

export function toastAfterReload(message, options = {}) {
  try {
    sessionStorage.setItem(PENDING_TOAST_KEY, JSON.stringify({ message, options }))
  } catch (e) {
    // sessionStorage unavailable — skip the toast rather than break the flow
  }
}

export function flushPendingToast() {
  try {
    const raw = sessionStorage.getItem(PENDING_TOAST_KEY)
    if (!raw) return
    sessionStorage.removeItem(PENDING_TOAST_KEY)
    const { message, options } = JSON.parse(raw)
    toast(message, options)
  } catch (e) {
    // ignore malformed or unavailable storage
  }
}
